module.exports = __webpack_public_path__ + "img/2249810.5ced4af0.png";